import styled from 'styled-components';

import { $dmSansFontFamily, colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Button } from '../components/Button';
import { EmptyStateView } from '../components/EmptyStateView';
import { HEADER_HEIGHT } from '../components/Header/styles';
import { NAV_HEIGHT } from '../components/Tabs/styles';

export const CONTAINER_MARGIN = 14;

export const StyledTabsContainer = styled.div`
  height: calc(100vh - ${HEADER_HEIGHT}px);
  overflow-y: auto;
  overflow-x: hidden;
`;

export const StyledSearchContainer = styled.div`
  height: calc(100vh - ${HEADER_HEIGHT}px - ${CONTAINER_MARGIN}px);
  overflow-y: scroll;
  border-radius: 8px 8px 0px 0px;
  display: flex;
  flex-direction: column;
`;

export const StyledContainer = styled.div`
  min-height: calc(100vh - ${HEADER_HEIGHT}px);
  margin: ${CONTAINER_MARGIN}px 24px 0;
  border-radius: 8px 8px 0px 0px;
  box-shadow: 0px -1px 16px 0px rgba(0, 0, 0, 0.05);
  border: 1px solid #efefef;
`;

export const StyledContainerWithNav = styled(StyledContainer)`
  min-height: calc(100vh - ${NAV_HEIGHT}px - ${HEADER_HEIGHT}px - ${CONTAINER_MARGIN}px);
  display: flex;
  flex-direction: column;
`;

export const StyledContactsContainerWithNav = styled.div`
  min-height: calc(100vh - ${NAV_HEIGHT}px - ${HEADER_HEIGHT}px - ${CONTAINER_MARGIN}px);
  display: flex;
  flex-direction: column;
  margin: 0 24px;
`;

export const StyledPageHeading = styled.h1`
  font-family: ${$dmSansFontFamily};
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: ${colorsPalettes.carbon[500]};
  width: 100%;
  margin: 0 0 8px;
`;

export const StyledSettingsPage = styled.div`
  height: calc(100vh - ${HEADER_HEIGHT}px);
  padding: 24px 24px 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
`;

export const StyledSettingsHeader = styled(StyledPageHeading)`
  display: flex;
  align-items: center;
  font-size: 18px;
  padding-bottom: 24px;
  margin-bottom: 0;
`;

export const StyledArrowButton = styled(Button)`
  margin-right: 4px;
  padding: 4px;
`;

export const StyledSettingTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const StyledSettingsTitle = styled.p`
  ${setFontVariant('input2', colorsPalettes.carbon[250])};
  font-size: 12px;
  line-height: 14px;
  margin: 24px 0 16px;
`;

export const StyledMeetingNoCompanyEmptyStateView = styled(EmptyStateView)`
  padding: 0 10px;
  margin-top: 36px;
`;
